import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";

export const OtherSettings: React.FC<any> = React.memo((props) => {
    const { register, control } = useFormContext();

    return (
        <Grid container spacing={2}>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="showheader"
              name="showheader"
              label="Show Section Header Section"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="show item modified name"
              name="show item modified name"
              label="Show Item Modified Name"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="showreceiptsummary"
              name="showreceiptsummary"
              label="Show Receipt Summary Section"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="amount including tax"
              name="amount including tax"
              label="Show Amount Including Tax"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="showmenusummary"
              name="showmenusummary"
              label="Show Menu Group Summary Section"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="ignoremodifier"
              name="ignoremodifier"
              label="Ignore Modifier Without Cost"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="shownochargesummary"
              name="shownochargesummary"
              label="Show No Charge Summary Section"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} sm={6}>
           <WSSCheckBoxField
              id="amountwhithdiscount"
              name="amountwhithdiscount"
              label="Amount With Item Discount"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} >
           <WSSCheckBoxField
              id="showadvanceorderpayment"
              name="showadvanceorderpayment"
              label="Show Advance Order Payment"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
           <Grid item xs={12} >
           <WSSCheckBoxField
              id="showordertypewisesale"
              name="showordertypewisesale"
              label="Show Order Type wise Sale"
              control={control}
              rules={{ required: false }}
              defaultValue={false}
            />
           </Grid>
            

          
        </Grid>
    );
});
